import React from "react";
import moment from "moment";

function useYears(stringify=false, start=1800, endYear = null) {
    let years = [];
    const end = endYear || moment().year();

    for (let index = end; index >= start; index--) {
        if(stringify){
            years.push({id: index.toString(), name: index.toString()})
        } else {
            years.push({id: index, name: index})
        }
    }

    return years;
}

export default useYears;